import { useDispatch, useSelector } from 'react-redux';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import ClosedLeadsEmptyState from './ClosedLeadsEmptyState';
import ClosedLeadsContent from './ClosedLeadsContent';
import PerformanceCard from '../PerformanceCard';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPerformanceClosedLeadsCard } from '@/store/slices/components/dashboard/service';
import { CLOSED_LEADS } from '../../constants';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';

export default function ClosedLeads() {
  const dispatch = useDispatch();
  const { closedLeads } = useSelector((state) => state.DashboardSlice);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();
  const { loading, hasFetched, options } = closedLeads;
  const showEmptyState = options[CLOSED_LEADS.CLOSING_REASON].list.length === 0;

  useFetchOnViewport(
    (query) => {
      dispatch(getPerformanceClosedLeadsCard({ query }));
    },
    [],
    { hasFetched }
  );

  const handleOpenTable = () => {
    dispatch(
      setPerformanceModals({
        key: 'closedLeads',
        subkey: 'isOpen',
        value: true,
      })
    );
  };

  return (
    <PerformanceCard ref={ref} loading={loading || isStale} id="closed-leads">
      <PerformanceCard.Header handleClickTableIcon={handleOpenTable}>
        {Trans(translations, 'ClosedContacts')}
      </PerformanceCard.Header>
      {showEmptyState ? <ClosedLeadsEmptyState /> : <ClosedLeadsContent />}
    </PerformanceCard>
  );
}
